import React from 'react';

const TermCondition3 = () => {
  const htmlContent = `
  
  <p style='margin-top:0in;margin-right:0in;margin-bottom:15.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;border:none;padding:0in;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">바디스위치 이용약관</span>
        </strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:16px;font-family:Gulim;color:#454545;">제</span>
        </strong>
        <strong>
          <span style="font-size:16px;font-family:Gulim;color:#454545;">1장 총칙</span>
        </strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">&nbsp;</span>
        </strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">제</span>
        </strong>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">1조 [목적]</span>
        </strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <span style="font-size:12px;font-family:Gulim;color:#454545;">
          본 약관은 주식회사 센트리얼(이하 &quot;회사&quot;라 한다) 및 회사가 운영하는 어플리케이션 (어플리케이션 명:
          바디스위치)를 통해 제공하는 디지털콘텐츠(이하 &quot;콘텐츠&quot;라 한다), 재화 및 각종 제반서비스의 이용과
          관련하여 회사와 이용자와의 권리, 의무 및 책임사항, 이용조건 등을 규정함을 목적으로 합니다.
        </span>
        &nbsp;
        <br />
        &nbsp;*&nbsp;
        <span style="font-size:12px;font-family:Gulim;color:#454545;">
          PC통신, 무선 등을 이용하는 전자상거래에 대해서도 그 성질에 반하지 않는 한 이 약관을 준용합니다.
        </span>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <span style="font-size:12px;font-family:Gulim;color:#454545;">&nbsp;</span>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">제</span>
        </strong>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">2조 [정의]</span>
        </strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <span style="font-size:12px;font-family:Gulim;color:#454545;">
          이 약관에서 사용하는 용어의 정의는 다음과 같습니다.
        </span>
      </p>
      <ol style="list-style-type: decimal;margin-left: 29.299999999999997px;">
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            &quot;회사&quot;이라 함은 콘텐츠 산업과 관련된 경제활동을 영위하는 자로서 콘텐츠 및 제반서비스를 제공하는
            자를 말합니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            &ldquo;플랫폼&rdquo; 이라 함은 회사에서 제공하는 어플리케이션 &ldquo;바디스위치&rdquo;를 통해 재화 또는
            용역(이하 &ldquo;재화 등&rdquo;이라 함)을 이용자에게 제공하기 위하여 컴퓨터 등 정보통신설비를 이용하여 재화
            등을 거래할 수 있도록 어플리케이션 내에 설정한 가상의 영업장을 말하며, 아울러 사이버몰을 운영하는 사업자의
            의미로도 사용합니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            &quot;이용자&quot;라 함은 회사에서 제공하는 어플리케이션&nbsp;&ldquo;바디스위치&rdquo;에 접속하여 이 약관에
            따라 회사가 제공하는 콘텐츠 및 제반서비스를 무료, 또는 유료로 이용하는 이용자 및 비이용자를 말합니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            &quot;이용자&quot;이라 함은 회사와 이용계약을 체결하고 아이디(ID)를 부여 받은 이용자로서 회사의 정보를
            지속적으로 제공받으며 회사가 제공하는 서비스를 지속적으로 이용할 수 있는 자를 말합니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            &quot;비이용자&quot;이라 함은 이용자가 아니면서 회사가 제공하는 서비스를 이용하는 자를 말합니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            &quot;콘텐츠&quot;라 함은 정보통신망이용촉진 및 정보보호 등에 관한 법률 제2조 제1항 제1호의 규정에 의한
            정보통신망에서 사용되는 부호&middot;문자&middot;음성&middot;음향&middot;이미지 또는 영상(스트리밍 또는 VOD)
            등으로 표현된 자료 또는 정보로서, 그 보존 및 이용에 있어서 효용을 높일 수 있도록 전자적 형태로 제작 또는
            처리된 것을 말합니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            &quot;아이디(ID)&quot;라 함은 이용자의 식별과 서비스이용을 위하여 사용되는 문자 또는 숫자의 조합을 말합니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            &quot;비밀번호(PASSWORD)&quot;라 함은 이용자임을 확인하고 비밀보호를 위해 이용자 자신이 정한 문자 또는
            숫자의 조합을 말합니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            본 약관에 사용되는 용어 중 본 조에서 정하지 아니한 부분은 관계법령 및 일반관례에 따릅니다.
          </span>
        </li>
      </ol>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;text-indent:-12.75pt;'>
        <span style="font-size:12px;font-family:Gulim;color:#454545;">&nbsp;</span>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">제</span>
        </strong>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">3조 [신원정보 등의 제공]</span>
        </strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <span style="font-size:12px;font-family:Gulim;color:#454545;">
          회사는 이 약관의 내용, 상호, 대표자 성명, 영업소 소재지 주소, 전화번호, 전자우편주소, 사업자등록번호,
          통신판매업 신고번호 및 개인정보관리책임자 등을 이용자가 쉽게 알 수 있도록 회사 어플리케이션 내에 위치한
          &lsquo;마이페이지&rsquo; 화면에 게시합니다.
        </span>{' '}
        <span style="font-size:12px;font-family:Gulim;color:#454545;">다만</span>
        <span style="font-size:12px;font-family:Gulim;color:#454545;">
          , 약관의 내용은 이용자가 연결화면을 통하여 볼 수 있도록 할 수 있습니다.
        </span>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">&nbsp;</span>
        </strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">제</span>
        </strong>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">4조 [약관의 게시 등]</span>
        </strong>
      </p>
      <ol style="list-style-type: decimal;margin-left: 28px;">
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사는 이 약관을 이용자가 그 전부를 인쇄할 수 있고 거래과정에서 해당 약관의 내용을 확인할 수 있도록 기술적
            조치를 취합니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사는 이용자가 회사와 이 약관의 내용에 관하여 질의 및 응답할 수 있도록 기술적 장치를 설치합니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사는 이용자가 약관에 동의하기에 앞서 약관에 정하여져 있는 내용 중 청약철회, 환불조건 등과 같은 중요한
            내용을 이용자가 쉽게 이해할 수 있도록 별도의 연결화면 또는 팝업화면 등을 제공하여 이용자의 확인을 구합니다.
          </span>
        </li>
      </ol>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <span style="font-size:12px;font-family:Gulim;color:#454545;">&nbsp;</span>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">제</span>
        </strong>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">5조 [약관의 개정 등]</span>
        </strong>
      </p>
      <ol style="list-style-type: decimal;margin-left: 28px;">
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사는 온라인 「디지털콘텐츠산업발전법」, 「전자상거래 등에서의 소비자보호에 관한 법률」, 「약관의 규제에
            관한 법률」, 「전자문서 및 전자거래기본법」, 「전자금융거래법」, 「전자서명법」, 「정보통신망 이용촉진 및
            정보보호 등에 관한 법률」, 「방문판매 등에 관한 법률」, 「소비자기본법」등 관련법을 위배하지 않는 범위에서
            이 약관을 개정할 수 있습니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 서비스 초기화면에 그 적용일자
            7일 이전부터 적용일 후 상당한 기간 동안 공지하고, 기존이용자에게는 개정약관을 전자우편주소로 발송합니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사가 약관을 개정할 경우에는 개정약관 공지 후 개정약관의 적용에 대한 이용자의 동의 여부를 확인합니다.
            이용자가 개정약관의 적용에 동의하지 않는 경우 회사 또는 이용자는 콘텐츠 이용계약을 해지할 수 있습니다. 이때,
            회사는 계약해지로 인하여 이용자가 입은 손해를 배상합니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>회사가</span>
          <span style="color:#454545;">
            &nbsp;2항에 따라 변경약관을 공지하였음에도 이용자가 명시적으로 변경약관에 대한 거부의사를 표시하지 아니한
            경우 이용자가 변경약관에 동의한 것으로 간주합니다.
          </span>
        </li>
      </ol>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">&nbsp;</span>
        </strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">제</span>
        </strong>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">6조 [약관의 해석]</span>
        </strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <span style="font-size:12px;font-family:Gulim;color:#454545;">
          이 약관에서 정하지 아니한 사항과 이 약관의 해석에 관하여는 「디지털콘텐츠산업발전법」, 「전자상거래 등에서의
          소비자보호에 관한 법률」, 「약관의 규제에 관한 법률」, 공정거래위원회가 정하는 &ldquo;전자상거래
        </span>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <span style="font-size:12px;font-family:Gulim;color:#454545;">
          등에서의 소비자 보호지침&rdquo; 및 정보통신부장관이 정하는 &quot;디지털콘텐츠이용자보호지침&quot;, 기타
          관계법령 또는 상관례에 따릅니다.
        </span>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:16px;font-family:Gulim;color:#454545;">&nbsp;</span>
        </strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:16px;font-family:Gulim;color:#454545;">제</span>
        </strong>
        <strong>
          <span style="font-size:16px;font-family:Gulim;color:#454545;">2장 이용자가입</span>
        </strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">&nbsp;</span>
        </strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">제</span>
        </strong>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">7조 [이용자가입]</span>
        </strong>
      </p>
      <ol style="list-style-type: decimal;margin-left: 28px;">
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            이용자가입은 이용자가 약관의 내용에 대하여 동의를 하고 이용자가입 신청을 한 후 회사가 이러한 신청에 대하여
            승낙함으로써 체결됩니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            이용자가입신청서에는 다음 사항을 기재해야 합니다.
          </span>
        </li>
      </ol>
      <ul style="list-style-type: undefined margin-left: 43.45px;">
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>아이디</span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>비밀번호</span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>전자우편주소</span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>휴대폰 번호</span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>닉네임</span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>생년월일</span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>성별</span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>주소</span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>매장</span>
          <span style="color:#454545;">(사업자)회원의 경우 하기 사항을 추가로 기재해야 합니다.</span>
        </li>
      </ul>
      <ol style="list-style-type: decimal;margin-left: 61.45px;">
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>사업장 이름</span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>사업장 주소</span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>사업자 명</span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>사업자 등록번호</span>
        </li>
      </ol>
      <ul style="list-style-type: undefined margin-left: 43.45px;">
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            기타 회사가 필요하다고 인정하는 사항
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사는 상기 이용자의 신청에 대하여 이용자가입을 승낙함을 원칙으로 합니다. 다만, 회사는 다음 각 호에 해당하는
            신청에 대하여는 승낙을 하지 않을 수 있습니다.
          </span>
        </li>
      </ul>
      <ol style="list-style-type: decimal;margin-left: 57.650000000000006px;">
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            가입신청자가 이 약관에 의하여 이전에 이용자자격을 상실한 적이 있는 경우
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            본인이 아닌 타인의 전자우편주소를 이용한 경우
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            허위의 정보를 기재하거나, 회사가 제시하는 내용을 기재하지 않은 경우
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            이용자의 귀책사유로 인하여 승인이 불가능하거나 기타 규정한 제반 사항을 위반하며 신청하는 경우
          </span>
        </li>
      </ol>
      <ol start="3" style="list-style-type: decimal;margin-left: 28px;">
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사는 서비스 관련 설비의 여유가 없거나, 기술상 또는 업무상 문제가 있는 경우에는 승낙을 유보할 수 있습니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            이용자가입계약의 성립 시기는 회사의 승낙이 이용자에게 도달한 시점으로 합니다.
          </span>
        </li>
      </ol>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">&nbsp;</span>
        </strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">제</span>
        </strong>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">8조 [미성년자의 이용자가입에 관한 특칙]</span>
        </strong>
      </p>
      <ol style="list-style-type: decimal;margin-left: 22.950000000000003px;">
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>만</span>
          <span style="color:#454545;">
            &nbsp;14세 미만의 이용자는 개인정보의 수집 및 이용목적에 대하여 충분히 숙지하고 부모 등 법정대리인의 동의를
            얻은 후에 이용자가입을 신청하고 본인의 개인정보를 제공하여야 합니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사는 부모 등 법정대리인의 동의에 대한 확인절차를 거치지 않은 14세 미만 이용자에 대하여는 가입을 취소 또는
            불허합니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>만</span>
          <span style="color:#454545;">
            &nbsp;14세 미만 이용자의 부모 등 법정대리인은 아동에 대한 개인정보의 열람, 정정, 갱신을 요청하거나
            이용자가입에 대한 동의를 철회할 수 있으며, 이러한 경우에 회사는 지체 없이 필요한 조치를 취해야 합니다.
          </span>
        </li>
      </ol>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">&nbsp;</span>
        </strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">제</span>
        </strong>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">9조 [이용자정보의 변경]</span>
        </strong>
      </p>
      <ol style="list-style-type: decimal;margin-left: 26.75px;">
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            이용자는 정보수정 화면을 통해 언제든지 자신의 개인정보를 열람하고 수정할 수 있습니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            이용자는 이용자가입신청 시 기재한 사항이 변경되었을 경우 온라인으로 수정을 하거나 전자우편 기타 방법으로
            회사에 대하여 그 변경사항을 알려야 합니다
          </span>
          <span style="color:#454545;">.</span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>제</span>
          <span style="color:#454545;">
            2항의 변경사항을 회사에 알리지 않아 발생한 불이익에 대하여 회사는 책임지지 않습니다.
          </span>
        </li>
      </ol>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">&nbsp;</span>
        </strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">제</span>
        </strong>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">
            10조 [이용자의 아이디 및 비밀번호의 관리에 대한 의무]
          </span>
        </strong>
      </p>
      <ol style="list-style-type: decimal;margin-left: 28px;">
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            이용자의 아이디와 비밀번호에 관한 관리책임은 이용자에게 있으며, 이를 제3자가 이용하도록 하여서는 안 됩니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            이용자는 아이디 및 비밀번호가 도용되거나 제3자에 의해 사용되고 있음을 인지한 경우에는 이를 즉시 회사에
            통지하고 회사의 안내에 따라야 합니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>제</span>
          <span style="color:#454545;">
            2항의 경우에 해당 이용자가 회사에 그 사실을 통지하지 않거나, 통지한 경우에도 회사의 안내에 따르지 않아
            발생한 불이익에 대하여 회사는 책임지지 않습니다.
          </span>
        </li>
      </ol>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <span style="font-size:12px;font-family:Gulim;color:#454545;">&nbsp;</span>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">제</span>
        </strong>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">11조 [이용자에 대한 통지]</span>
        </strong>
      </p>
      <ol style="list-style-type: decimal;margin-left: 28px;">
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사가 이용자에 대한 통지를 하는 경우 앱 서비스 내 알림 메시지 또는 이용자가 지정한 전자우편주소로 할 수
            있습니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사는 이용자 전체에 대한 통지의 경우 7일 이상 회사의 게시판에 게시함으로써 제1항의 통지에 갈음할 수
            있습니다. 다만, 이용자 본인의 거래와 관련하여 중대한 영향을 미치는 사항에 대하여는 제1항의 통지를 합니다.
          </span>
        </li>
      </ol>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <span style="font-size:12px;font-family:Gulim;color:#454545;">&nbsp;</span>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">제</span>
        </strong>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">12조 [이용자탈퇴 및 자격 상실 등]</span>
        </strong>
      </p>
      <ol style="list-style-type: decimal;margin-left: 28px;">
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            이용자는 회사에 언제든지 탈퇴를 요청할 수 있으며 회사는 즉시 이용자탈퇴를 처리합니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            이용자가 다음 각호의 사유에 해당하는 경우, 회사는 이용자자격을 제한 및 정지시킬 수 있습니다.
          </span>
          <ul style="list-style-type: undefined margin-left: 37.1px;">
            <li>
              <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
                가입신청 시에 허위내용을 등록한 경우
              </span>
            </li>
            <li>
              <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
                회사의 서비스 이용대금 및, 기타 회사의 서비스이용에 관련하여 이용자가 부담하는 채무를 기일에 이행하지
                않는 경우
              </span>
            </li>
            <li>
              <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
                다른 이용자의 회사의 서비스이용을 방해하거나 그 정보를 도용하는 등 전자상거래 질서를 위협하는 경우
              </span>
            </li>
            <li>
              <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
                회사를 이용하여 법령 또는 이 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우
              </span>
            </li>
          </ul>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사가 이용자자격을 제한&middot;정지시킨 후, 동일한 행위가 2회 이상 반복되거나 30일 이내에 그 사유가
            시정되지 아니하는 경우 회사는 이용자자격을 상실시킬 수 있습니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사가 이용자자격을 상실시키는 경우에는 이용자등록을 말소합니다. 이 경우 이용자에게 이를 통지하고,
            이용자등록 말소 전에 최소한 30일 이상의 기간을 정하여 소명할 기회를 부여합니다.
          </span>
        </li>
      </ol>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:16px;font-family:Gulim;color:#454545;">&nbsp;</span>
        </strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:16px;font-family:Gulim;color:#454545;">제</span>
        </strong>
        <strong>
          <span style="font-size:16px;font-family:Gulim;color:#454545;">3장 콘텐츠 이용 및 재화 구매에 대한 계약</span>
        </strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">&nbsp;</span>
        </strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">제</span>
        </strong>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">13조 [콘텐츠 및 재화의 내용 등의 게시]</span>
        </strong>
      </p>
      <ol style="list-style-type: decimal;margin-left: 28px;">
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사는 다음 사항을 해당 콘텐츠의 이용초기화면 등에 이용자가 알기 쉽게 표시합니다.
          </span>
        </li>
      </ol>
      <ul style="list-style-type: undefined margin-left: 46px;">
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>콘텐츠의 명칭 또는 제호</span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>콘텐츠의 제작 및 표시 연월일</span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            콘텐츠 제작자의 성명(법인인 경우에는 법인의 명칭), 주소, 전화번호
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            콘텐츠의 내용, 이용방법, 이용료 기타 이용조건
          </span>
        </li>
      </ul>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">&nbsp;</span>
        </strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">제</span>
        </strong>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">14조 [콘텐츠 이용]</span>
        </strong>
      </p>
      <ol style="list-style-type: decimal;margin-left: 28px;">
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사는 이용자의 콘텐츠 이용에 대한 신청이 다음 각 호에 해당하는 경우에는 승낙하지 않거나 승낙을 유보할 수
            있습니다.
          </span>
        </li>
      </ol>
      <ul style="list-style-type: undefined margin-left: 46px;">
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            실명이 아니거나 타인의 명의를 이용한 경우
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            허위의 정보를 기재하거나, 회사가 제시하는 내용을 기재하지 않은 경우
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            미성년자가 청소년보호법에 의해서 이용이 금지되는 콘텐츠를 이용 또는 구매하고자 하는 경우
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            서비스 관련 설비의 여유가 없거나, 기술상 또는 업무상 문제가 있는 경우
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            명의자의 동의나 승낙없이 결제 수단을 무단 도용하여 이용요금을 결제한 경우
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            그 밖에 이용자의 귀책사유로 승인이 불가능하다고 판단되는 경우
          </span>
        </li>
      </ul>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <span style="font-size:12px;font-family:Gulim;color:#454545;">&nbsp;</span>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">제</span>
        </strong>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">15조 [미성년자 이용계약에 관한 특칙]</span>
        </strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <span style="font-size:12px;font-family:Gulim;color:#454545;">
          회사는 만 20세 미만의 미성년이용자가 유료서비스를 이용하고자 하는 경우에 부모 등 법정 대리인의 동의를 얻거나,
          계약체결 후 추인을 얻지 않으면 미성년자 본인 또는 법정대리인이 그 계약을 취소할 수 있다는 내용을 계약체결 전에
          고지하는 조치를 취합니다.
        </span>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">&nbsp;</span>
        </strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">제</span>
        </strong>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">
            16조 [수신확인통지, 이용신청, 구매신청 변경 및 취소]
          </span>
        </strong>
      </p>
      <ol style="list-style-type: decimal;margin-left: 28px;">
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사는 이용자의 컨텐츠 이용 시 필요에 따라 이용자에게 수신확인통지를 합니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            수신확인통지를 받은 이용자는 의사표시의 불일치 등이 있는 경우에는 수신확인통지를 받은 후 즉시 이용신청 변경
            및 취소를 요청할 수 있고
          </span>
          <span style="color:#454545;">
            , 회사는 서비스제공 전에 이용자의 요청이 있는 경우에는 지체 없이 그 요청에 따라 처리하여야 합니다.
          </span>
        </li>
      </ol>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <span style="font-size:12px;font-family:Gulim;color:#454545;">&nbsp;</span>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">제</span>
        </strong>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">17조 [회사의 의무]</span>
        </strong>
      </p>
      <ol style="list-style-type: decimal;margin-left: 28px;">
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사는 법령과 이 약관이 정하는 권리의 행사와 의무의 이행을 신의에 좇아 성실하게 하여야 합니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사는 이용자가 안전하게 콘텐츠를 이용할 수 있도록 개인정보(신용정보 포함)보호를 위해 보안시스템을 갖추어야
            하며 개인정보보호정책을 공시하고 준수합니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사는 이용자가 콘텐츠 이용 및 그 대금내역을 수시로 확인할 수 있도록 조치합니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사는 콘텐츠 이용과 관련하여 이용자로부터 제기된 의견이나 불만이 정당하다고 인정할 경우에는 이를 지체 없이
            처리합니다. 이용자가 제기한 의견이나 불만사항에 대해서는 게시판을 활용하거나 전자우편 등을 통하여 그
            처리과정 및 결과를 전달합니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사는 이 약관에서 정한 의무 위반으로 인하여 이용자가 입은 손해를 배상합니다.
          </span>
        </li>
      </ol>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">&nbsp;</span>
        </strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">제</span>
        </strong>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">18조 [이용자의 의무]</span>
        </strong>
      </p>
      <ol style="list-style-type: decimal;margin-left: 28px;">
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            이용자는 다음 행위를 하여서는 안 됩니다.
          </span>
        </li>
      </ol>
      <ul style="list-style-type: undefined margin-left: 43.45px;">
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            신청 또는 변경 시 허위내용의 기재
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>타인의 정보도용</span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>회사에 게시된 정보의 변경</span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>회사가 금지한 정보</span>
          <span style="color:#454545;">(컴퓨터 프로그램 등)의 송신 또는 게시</span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>회사와 기타 제</span>
          <span style="color:#454545;">3자의 저작권 등 지적재산권에 대한 침해</span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>회사 및 기타 제</span>
          <span style="color:#454545;">3자의 명예를 손상시키거나 업무를 방해하는 행위</span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            외설 또는 폭력적인 말이나 글, 화상, 음향, 기타 공서양속에 반하는 정보를 회사의 사이트에 공개 또는 게시하는
            행위
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>기타 불법적이거나 부당한 행위</span>
        </li>
      </ul>
      <ol start="2" style="list-style-type: decimal;margin-left: 28px;">
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>이용자는 관계법령</span>
          <span style="color:#454545;">
            , 이 약관의 규정, 이용안내 및 콘텐츠와 관련하여 공지한 주의사항, 회사가 통지하는 사항 등을 준수하여야 하며,
            기타 회사의 업무에 방해되는 행위를 하여서는 안 됩니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>본 조 제</span>
          <span style="color:#454545;">
            1항과 제2항에 명시된 행위를 통해 발생한 불이익에 대하여 회사는 책임지지 않습니다
          </span>
        </li>
      </ol>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <span style="font-size:12px;font-family:Gulim;color:#454545;">&nbsp;</span>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">제</span>
        </strong>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">19조 [서비스의 제공 및 중단]</span>
        </strong>
      </p>
      <ol style="list-style-type: decimal;margin-left: 28px;">
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>서비스는 연중무휴</span>
          <span style="color:#454545;">, 1일 24시간 제공함을 원칙으로 합니다.</span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신두절 또는 운영상 상당한 이유가 있는 경우
            서비스의 제공을 일시적으로 중단할 수 있습니다. 이 경우 회사는 제11조[이용자에 대한 통지]에 정한 방법으로
            이용자에게 통지합니다. 다만, 회사가 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수
            있습니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사는 상당한 이유 없이 서비스의 제공이 일시적으로 중단됨으로 인하여 이용자가 입은 손해에 대하여 배상합니다.
            다만, 회사가 고의 또는 과실이 없음을 입증하는 경우에는 그러하지 아니합니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사는 서비스의 제공에 필요한 경우 정기점검을 실시할 수 있으며, 정기점검시간은 서비스제공화면에 공지한 바에
            따릅니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>사업종목의 전환</span>
          <span style="color:#454545;">
            , 사업의 포기, 업체 간의 통합 등의 이유로 서비스를 제공할 수 없게 되는 경우에는 회사는 제11조[이용자에 대한
            통지]에 정한 방법으로 이용자에게 통지하고 당초 회사에서 제시한 조건에 따라 이용자에게 보상합니다.
          </span>
        </li>
      </ol>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <span style="font-size:12px;font-family:Gulim;color:#454545;">&nbsp;</span>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">제</span>
        </strong>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">20조 [서비스의 변경]</span>
        </strong>
      </p>
      <ol style="list-style-type: decimal;margin-left: 28px;">
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사는 상당한 이유가 있는 경우에 운영상, 기술상의 필요에 따라 제공하고 있는 서비스를 변경할 수 있습니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사는 서비스의 내용, 이용방법, 이용시간을 변경할 경우에 변경사유, 변경될 서비스의 내용 및 제공일자 등을 그
            변경 전 7일 이상 해당 어플리케이션 초기화면에 게시합니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>제</span>
          <span style="color:#454545;">
            2항의 경우에 변경된 내용이 중대하거나 이용자에게 불리한 경우에는 회사가 해당 서비스를 제공받는 이용자에게
            제11조[이용자에 대한 통지]에 정한 방법으로 통지하고 동의를 받습니다. 이때, 회사는 동의를 거절한 이용자에
            대하여는 변경전 서비스를 제공합니다. 다만, 그러한 서비스 제공이 불가능할 경우 계약을 해지할 수 있습니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>회사는 제</span>
          <span style="color:#454545;">
            1항에 의한 서비스의 변경 및 제3항에 의한 계약의 해지로 인하여 이용자가 입은 손해를 배상합니다.
          </span>
        </li>
      </ol>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <span style="font-size:12px;font-family:Gulim;color:#454545;">&nbsp;</span>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">제</span>
        </strong>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">21조 [정보의 제공 및 광고의 게재]</span>
        </strong>
      </p>
      <ol style="list-style-type: decimal;margin-left: 28px;">
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사는 이용자가 콘텐츠 이용 중 필요하다고 인정되는 다양한 정보를 공지사항이나 전자우편 등의 방법으로
            이용자에게 제공할 수 있습니다. 다만, 이용자는 언제든지 전자우편 등을 통하여 수신 거절을 할 수 있습니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>제</span>
          <span style="color:#454545;">
            1항의 정보를 전화 및 모사전송기기에 의하여 전송하려고 하는 경우에는 이용자의 사전 동의를 받아서 전송합니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사는 콘텐츠서비스 제공과 관련하여 콘텐츠 화면, 홈페이지, 전자우편 등에 광고를 게재할 수 있습니다. 광고가
            게재된 전자우편 등을 수신한 이용자는 수신거절을 회사에게 할 수 있습니다.
          </span>
        </li>
      </ol>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <span style="font-size:12px;font-family:Gulim;color:#454545;">&nbsp;</span>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">제</span>
        </strong>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">22조 [게시물의 삭제]</span>
        </strong>
      </p>
      <ol style="list-style-type: decimal;margin-left: 28px;">
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사는 게시판에 정보통신망이용촉진 및 정보보호 등에 관한 법률을 위반한 청소년유해매체물이 게시되어 있는
            경우에는 이를 지체 없이 삭제 합니다
          </span>
          <span style="color:#454545;">. 다만, 19세 이상의 이용자만 이용할 수 있는 게시판은 예외로 합니다.</span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사가 운영하는 게시판 등에 게시된 정보로 인하여 법률상 이익이 침해된 자는 회사에게 당해 정보의 삭제 또는
            반박내용의 게재를 요청할 수 있습니다
          </span>
          <span style="color:#454545;">
            . 이 경우 회사는 지체 없이 필요한 조치를 취하고 이를 즉시 신청인에게 통지합니다.
          </span>
        </li>
      </ol>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <span style="font-size:12px;font-family:Gulim;color:#454545;">&nbsp;</span>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">제</span>
        </strong>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">23조 [저작권 등의 귀속]</span>
        </strong>
      </p>
      <ol style="list-style-type: decimal;margin-left: 28px;">
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사가 작성한 저작물에 대한 저작권 기타 지적재산권은 회사에 귀속합니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사가 제공하는 서비스 중 제휴계약에 의해 제공되는 저작물에 대한 저작권 기타 지적재산권은 해당 제공자나
            제공업체에 귀속합니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            이용자는 회사가 제공하는 서비스를 이용함으로써 얻은 정보 중 회사 또는 제공업체에 지적재산권이 귀속된 정보를
            회사 또는 제공업체의 사전승낙 없이 복제
          </span>
          <span style="color:#454545;">
            , 전송, 출판, 배포, 방송 기타 방법에 의하여 영리목적으로 이용하거나 제3자에게 이용하게 하여서는 안 됩니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사는 약정에 따라 이용자의 저작물을 사용하는 경우 당해 이용자에게 통보하여야 합니다.
          </span>
        </li>
      </ol>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <span style="font-size:12px;font-family:Gulim;color:#454545;">&nbsp;</span>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">제</span>
        </strong>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">24조 [개인정보보호]</span>
        </strong>
      </p>
      <ol style="list-style-type: decimal;margin-left: 28px;">
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>회사는 제</span>
          <span style="color:#454545;">
            7조 제2항의 신청서기재사항 이외에 이용자의 콘텐츠 이용 및 재화 구매에 필요한 정보를 수집할 수 있습니다. 이를
            위해 회사가 문의한 사항에 관해 이용자는 진실한 내용을 성실하게 고지하여야 합니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사가 이용자의 개인 식별이 가능한 개인정보를 수집하는 때에는 당해 이용자의 동의를 받습니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사는 이용자가 이용신청 등에서 제공한 정보와 제1항에 의하여 수집한 정보를 당해 이용자의 동의 없이 목적 외로
            이용하거나 제3자에게 제공할 수 없으며, 이를 위반한 경우에 모든 책임은 회사가 집니다. 다만, 다음의 경우에는
            예외로 합니다.
          </span>
        </li>
      </ol>
      <ul style="list-style-type: undefined margin-left: 46px;">
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>통계작성</span>
          <span style="color:#454545;">
            , 학술연구 또는 시장조사를 위하여 필요한 경우로서 특정 개인을 식별할 수 없는 형태로 제공하는 경우
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            콘텐츠 제공에 따른 요금정산을 위하여 필요한 경우
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            도용방지를 위하여 본인확인에 필요한 경우
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            약관의 규정 또는 법령에 의하여 필요한 불가피한 사유가 있는 경우
          </span>
        </li>
      </ul>
      <ol start="4" style="list-style-type: decimal;margin-left: 28px;">
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>회사가 제</span>
          <span style="color:#454545;">
            2항과 제3항에 의해 이용자의 동의를 받아야 하는 경우에는 개인정보관리책임자의 신원(소속, 성명 및 전화번호
            기타 연락처), 정보의 수집목적 및 이용목적, 제3자에 대한 정보제공관련사항(제공받는 자, 제공목적 및 제공할
            정보의 내용)등에 관하여 정보통신망이용촉진 및 정보보호 등에 관한 법률 제22조 제2항이 규정한 사항을 명시하고
            고지하여야 합니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            이용자는 언제든지 제3항의 동의를 임의로 철회할 수 있습니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            이용자는 언제든지 회사가 가지고 있는 자신의 개인정보에 대해 열람 및 오류의 정정을 요구할 수 있으며, 회사는
            이에 대해 지체 없이 필요한 조치를 취할 의무를 집니다. 이용자가 오류의 정정을 요구한 경우에는 회사는 그
            오류를 정정할 때까지 당해 개인정보를 이용하지 않습니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사는 개인정보보호를 위하여 관리자를 한정하여 그 수를 최소화하며, 신용카드, 은행계좌 등을 포함한 이용자의
            개인정보의 분실, 도난, 유출, 변조 등으로 인한 이용자의 손해에 대하여 책임을 집니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사 또는 그로부터 개인정보를 제공받은 자는 이용자가 동의한 범위 내에서 개인정보를 사용할 수 있으며, 목적이
            달성된 경우에는 당해 개인정보를 지체 없이 파기합니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사는 개인정보의 수집&middot;이용&middot;제공에 관한 동의 란을 미리 선택한 것으로 설정해두지 않습니다. 또한
            개인정보의 수집&middot;이용&middot;제공에 관한 이용자의 동의거절 시 제한되는 서비스를 구체적으로 명시하고,
            필수수집항목이 아닌 개인정보의 수집&middot;이용&middot;제공에 관한 이용자의 동의 거절을 이유로 이용자가입 등
            서비스 제공을 제한하거나 거절하지 않습니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사는 정보통신망이용촉진 및 정보보호에 관한 법률 등 관계 법령이 정하는 바에 따라 이용자의 개인정보를
            보호하기 위해 노력합니다. 개인정보의 보호 및 사용에 대해서는 관련법령 및 회사의 개인정보보호정책이
            적용됩니다.
          </span>
        </li>
      </ol>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <span style="font-size:12px;font-family:Gulim;color:#454545;">&nbsp;</span>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:16px;font-family:Gulim;color:#454545;">제</span>
        </strong>
        <strong>
          <span style="font-size:16px;font-family:Gulim;color:#454545;">
            4장 콘텐츠이용계약의 청약철회, 계약해제&middot;해지 및 이용제한
          </span>
        </strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">&nbsp;</span>
        </strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">제</span>
        </strong>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">
            25조 [이용자의 청약철회와 계약해제&middot;해지]
          </span>
        </strong>
      </p>
      <ol style="list-style-type: decimal;margin-left: 28px;">
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사와 콘텐츠의 이용에 관한 계약을 체결한 이용자는 수신확인의 통지를 받은 날로부터 7일 이내에는 청약의
            철회를 할 수 있습니다. 다만, 회사가 다음 각 호중 하나의 조치를 취한 경우에는 이용자의 청약철회권이 제한될 수
            있습니다.
          </span>
        </li>
      </ol>
      <ul style="list-style-type: undefined margin-left: 46px;">
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            청약의 철회가 불가능한 콘텐츠에 대한 사실을 표시사항에 포함한 경우
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>시용상품을 제공한 경우</span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            한시적 또는 일부 이용 등의 방법을 제공한 경우
          </span>
        </li>
      </ul>
      <ol start="2" style="list-style-type: decimal;margin-left: 28px;">
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            이용자는 다음 각 호의 사유가 있을 때에는 당해 콘텐츠를 공급받은 날로부터 3월 이내 또는 그 사실을 안 날 또는
            알 수 있었던 날부터 30일 이내에 콘텐츠 이용계약을 해제&middot;해지할 수 있습니다.
          </span>
        </li>
      </ol>
      <ul style="list-style-type: undefined margin-left: 46px;">
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            이용계약에서 약정한 콘텐츠가 제공되지 않는 경우
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            제공되는 콘텐츠가 표시&middot;광고 등과 상이하거나 현저한 차이가 있는 경우
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            기타 콘텐츠의 결함으로 정상적인 이용이 현저히 불가능한 경우
          </span>
        </li>
      </ul>
      <ol start="3" style="list-style-type: decimal;margin-left: 28px;">
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>제</span>
          <span style="color:#454545;">
            1항의 청약철회와 제2항의 계약해제&middot;해지는 이용자가 전화, 전자우편 또는 모사전송으로 회사에 그 의사를
            표시한 때에 효력이 발생합니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>회사는 제</span>
          <span style="color:#454545;">
            3항에 따라 이용자가 표시한 청약철회 또는 계약해제&middot;해지의 의사표시를 수신한 후 지체 없이 이러한 사실을
            이용자에게 회신합니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>이용자는 제</span>
          <span style="color:#454545;">
            2항의 사유로 계약해제&middot;해지의 의사표시를 하기 전에 상당한 기간을 정하여 완전한 콘텐츠 혹은
            서비스이용의 하자에 대한 치유를 요구할 수 있습니다.
          </span>
        </li>
      </ol>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <span style="font-size:12px;font-family:Gulim;color:#454545;">&nbsp;</span>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <span style="font-size:12px;font-family:Gulim;color:#454545;">&nbsp;</span>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">제</span>
        </strong>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">
            29조 [회사의 계약해제&middot;해지 및 이용제한]
          </span>
        </strong>
      </p>
      <ol style="list-style-type: decimal;margin-left: 28px;">
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>회사는 이용자가 제</span>
          <span style="color:#454545;">
            12조 제2항에서 정한 행위를 하였을 경우 사전통지 없이 계약을 해제&middot;해지하거나 또는 기간을 정하여
            서비스이용을 제한할 수 있습니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>제</span>
          <span style="color:#454545;">
            1항의 해제&middot;해지는 회사가 자신이 정한 통지방법에 따라 이용자에게 그 의사를 표시한 때에 효력이
            발생합니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사의 해제&middot;해지 및 이용제한에 대하여 이용자는 회사가 정한 절차에 따라 이의신청을 할 수 있습니다. 이
            때 이의가 정당하다고 회사가 인정하는 경우, 회사는 즉시 서비스의 이용을 재개합니다.
          </span>
        </li>
      </ol>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <span style="font-size:12px;font-family:Gulim;color:#454545;">&nbsp;</span>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">제</span>
        </strong>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">30조 [회사의 계약해제&middot;해지의 효과]</span>
        </strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <span style="font-size:12px;font-family:Gulim;color:#454545;">
          이용자의 귀책사유에 따른 이용계약의 해제&middot;해지의 효과는 제28조를 준용합니다. 다만, 회사는 이용자에
          대하여 계약해제&middot;해지의 의사표시를 한 날로부터 7영업일 이내에 대금의 결제와 동일한 방법으로 이를
          환급합니다.
        </span>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <span style="font-size:12px;font-family:Gulim;color:#454545;">&nbsp;</span>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:16px;font-family:Gulim;color:#454545;">제</span>
        </strong>
        <strong>
          <span style="font-size:16px;font-family:Gulim;color:#454545;">6장 과오금, 피해보상 등</span>
        </strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">&nbsp;</span>
        </strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">&nbsp;</span>
        </strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">제</span>
        </strong>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">
            31조 [콘텐츠하자 등에 의한 이용자피해보상]
          </span>
        </strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <span style="font-size:12px;font-family:Gulim;color:#454545;">
          회사는 콘텐츠 하자 등에 의한 이용자피해보상의 기준&middot;범위&middot;방법 및 절차에 관한 사항을 디지털 콘텐츠
          이용자 보호지침에 따라 처리합니다.
        </span>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">&nbsp;</span>
        </strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">제</span>
        </strong>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">32조 [면책조항]</span>
        </strong>
      </p>
      <ol style="list-style-type: decimal;margin-left: 28px;">
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 콘텐츠를 제공할 수 없는 경우에는 콘텐츠 제공에 관한
            책임이 면제됩니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사는 이용자의 귀책사유로 인한 콘텐츠이용의 장애에 대하여는 책임을 지지 않습니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사는 이용자가 콘텐츠와 관련하여 게재한 정보, 자료, 사실의 신뢰도, 정확성 등의 내용에 관하여는 책임을 지지
            않습니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사는 이용자 상호간 또는 이용자와 제3자 간에 콘텐츠를 매개로 하여 발생한 분쟁 등에 대하여 책임을 지지
            않습니다.
          </span>
        </li>
      </ol>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">&nbsp;</span>
        </strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">제</span>
        </strong>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">33조 [분쟁의 해결]</span>
        </strong>
      </p>
      <ol style="list-style-type: decimal;margin-left: 28px;">
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            회사는 분쟁이 발생하였을 경우에 이용자가 제기하는 정당한 의견이나 불만을 반영하여 적절하고 신속한 조치를
            취합니다. 다만, 신속한 처리가 곤란한 경우에 회사는 이용자에게 그 사유와 처리일정을 통보합니다.
          </span>
        </li>
        <li>
          <span style='font-family:"Malgun Gothic";font-size:12px;color:#454545;'>
            이용자 간에 발생한 전자상거래 분쟁과 관련하여 이용자의 피해구제신청이 있는 경우에는 공정거래위원회 또는
            시&middot;도지사가 의뢰하는 분쟁조정기관의 조정에 따를 수 있습니다.
          </span>
        </li>
      </ol>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:justify;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">&nbsp;</span>
        </strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:justify;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">본 약관은 </span>
        </strong>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">2043년 5월 15일부터 시행합니다.</span>
        </strong>
      </p>
  `;

  return (
    <div>
      <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
    </div>
  );
};

export default TermCondition3;
